import WritingStylesManager from '@/components/writing-styles/WritingStylesManager';

const WritingStylesPage = () => {
  return (
    <div className="container mx-auto py-8 px-4 max-w-7xl">
      <WritingStylesManager />
    </div>
  );
};

export default WritingStylesPage;
